// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };
//         this.mql = window.matchMedia('(min-width: 750px)');
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId, prepend) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) {
//           return;
//         }
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         if (prepend) {
//           activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

//           if (this.elements.thumbnails) {
//             const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//             activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
//           }

//           if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//         }

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (!this.mql.matches || this.elements.thumbnails) {
//             activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           // Don't scroll if the image is already in view
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.thumbnailItems = Array.from(
          this.elements.thumbnails.querySelectorAll('[data-target]')
        );

        this.thumbnailItems.forEach((mediaToSwitch) => {
          const button = mediaToSwitch.querySelector('button');

          if (!button) return;

          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          });
        });

        this.bindInfiniteThumbnailNavigation();

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      bindInfiniteThumbnailNavigation() {
        this.elements.thumbnails.addEventListener(
          'click',
          (event) => {
            const prevButton = event.target.closest('.slider-button--prev');
            const nextButton = event.target.closest('.slider-button--next');

            if (!prevButton && !nextButton) return;

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const activeButton = this.elements.thumbnails.querySelector(
              '.thumbnail[aria-current="true"]'
            );

            const activeItem = activeButton
              ? activeButton.closest('[data-target]')
              : this.thumbnailItems[0];

            let activeIndex = this.thumbnailItems.indexOf(activeItem);

            if (activeIndex < 0) activeIndex = 0;

            if (prevButton) {
              activeIndex = activeIndex - 1;
            }

            if (nextButton) {
              activeIndex = activeIndex + 1;
            }

            if (activeIndex < 0) {
              activeIndex = this.thumbnailItems.length - 1;
            }

            if (activeIndex >= this.thumbnailItems.length) {
              activeIndex = 0;
            }

            const targetThumbnail = this.thumbnailItems[activeIndex];

            if (!targetThumbnail) return;

            this.setActiveMedia(targetThumbnail.dataset.target, false);
          },
          true
        );
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

            if (activeThumbnail) {
              activeThumbnail.parentElement.firstChild !== activeThumbnail &&
                activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth',
            });
          }

          const activeMediaRect = activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          const top = activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );

        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
          element.removeAttribute('aria-current');
        });

        const button = thumbnail.querySelector('button');

        if (button) {
          button.setAttribute('aria-current', 'true');
        }

        if (this.elements.thumbnails.isSlideVisible?.(thumbnail, 10)) return;

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({
            left: thumbnail.offsetLeft,
            behavior: 'smooth',
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');

        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}